import Dropdown from '@cbgms/components/form/Dropdown'
import { KnockFormDropdownLogic, KnockFormDropdownProps } from '@carsys/form/src/KnockFormDropdown'

export function KnockFormDropdown<T>(props: Omit<KnockFormDropdownProps<T>, 'DropdownComponent'>) {
  return <KnockFormDropdownLogic {...props} selection DropdownComponent={Dropdown} />
}
